import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import FormHelperText from '@mui/material/FormHelperText';

import moment from 'moment';
import React, { Fragment, useCallback } from 'react';
import { FormGroup, Label } from 'reactstrap';
import './form_date.scss';
import { DatePicker } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
const MomentDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

export interface FormTimeInputProps extends FieldProps<FormControl<string> | FormControl<string | null>> {
  onChange?(date: string | null): void;
  withoutGroup?: boolean;
  asterisk?: boolean;
  clearable?: boolean;
}

export function FormTimeInput(props: FormTimeInputProps) {
  const { formControl, fieldState, fieldConfig } = useFormField(props);

  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? moment(fieldState.value, 'H:mm') : null;
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const fieldReadonly = fieldConfig.readonly || false;
  const fieldDisabled = fieldConfig.disabled || false;

  const fieldPlaceholder = fieldConfig.placeholder || 'mm/dd/yyyy';

  const content = (
    <Fragment>
      {fieldConfig.label && (
        <Label for={formControl.uid}>
          {fieldConfig.label} {fieldConfig.required && props.asterisk && <span className="text-danger">*</span>}
        </Label>
      )}

      <MomentDatePicker
        picker={'time'}
        disabled={fieldDisabled}
        readOnly={fieldReadonly}
        placeholder={fieldPlaceholder}
        use12Hours
        value={fieldValue}
        format={'h:mm a'}
        minuteStep={15}
        allowClear={props.clearable || false}
        popupStyle={{ zIndex: 9999 }}
        onChange={(value: Moment) => {
          if (value) {
            formControl.setValue(value.format('HH:mm'));
            props.onChange && props.onChange(value.format('HH:mm'));
          } else {
            formControl.setValue(null);
            props.onChange && props.onChange(null);
          }
        }}
      />
      {!!fieldError && (
        <FormHelperText className="mui-error" style={{ color: '#f44336' }}>
          {fieldError}
        </FormHelperText>
      )}
    </Fragment>
  );

  if (props.withoutGroup) {
    return <div className="theme_date-picker d-flex flex-column">{content}</div>;
  }

  return <FormGroup className="theme_date-picker d-flex flex-column">{content}</FormGroup>;
}
